import React from "react";
import { ConfigProvider, DatePicker } from "antd";
import { colors } from "../../theme/colors.js";
import "./styles.css";

const { RangePicker } = DatePicker;

// The design-system wrapper around antd's RangePicker, matching
// common/date-picker and common/text-input: Figtree at 14px, a 4px radius and
// a strokeDark border, with the brand colour on focus and in the calendar.
// Dropped in raw, antd's own defaults (different font, radius, height and a
// non-brand focus colour) read as a foreign control next to the app's inputs.
const DateRangePicker = ({
  value,
  onChange,
  presets,
  format = "YYYY-MM-DD",
  allowClear = false,
  className = "",
  ...rest
}) => (
  <ConfigProvider
    theme={{
      token: {
        colorPrimary: colors.primaryColor,
        colorBorder: colors.strokeDark,
        colorText: colors.darkText,
        colorTextPlaceholder: colors.lightText,
        borderRadius: 4,
        fontFamily: "Figtree, sans-serif",
        fontSize: 14,
      },
    }}
  >
    <RangePicker
      className={`date-range-picker ${className}`}
      value={value}
      onChange={onChange}
      presets={presets}
      format={format}
      allowClear={allowClear}
      {...rest}
    />
  </ConfigProvider>
);

export default DateRangePicker;
